import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { APPCONFIG } from '../config';
import { MaterialModule,MdDialog, MdDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { LayoutService } from '../layout/layout.service';
import { SessionHandler } from '../shared/services/session-handler.service';

@Component({
    template: require('./dialog.component.html'),
})
export class dialogComponent implements OnInit {
    public msg:any;
    
    public isConfirm:boolean  = false;
    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<dialogComponent>)
    {}

    ngOnInit() {
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./termsDialogComponent.html')
})
export class termsDialogComponent implements OnInit {
    public msg:any;
    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<dialogComponent>)
    {}

    ngOnInit():void{
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./icbtermsDialogComponent.html'),
    providers:[SessionHandler]
})
export class icbtermsDialogComponent implements OnInit {
    public msg:any;
    public lan:any;
    constructor(private sessionHandler:SessionHandler,public dialog: MdDialog,public dialogRef: MdDialogRef<dialogComponent>)
    {}

    ngOnInit():void{
        this.lan = this.sessionHandler.getItem("defaultLanguage");
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./privacy.html'),
    providers:[SessionHandler]
})
export class privacyComponent implements OnInit {
    public msg:any;
    public lan:any;
    constructor(private sessionHandler:SessionHandler,public dialog: MdDialog,public dialogRef: MdDialogRef<dialogComponent>)
    {}

    ngOnInit():void{
        this.lan = this.sessionHandler.getItem("defaultLanguage");
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dialog/dialog.component.ts